/* tslint:disable */
/* eslint-disable */
/**
 * RakuLogi API
 * RakuLogi の API ドキュメント
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  RequestBulkRegisterAmazonItemsRequest,
  RequestGetAmazonItemsListRequest,
  RequestGetReportItemsCsvListRequest,
  RequestGetTaskProgressRequest,
  RequestRegistAmazonItemsRequest,
  RequestRestoreAmazonItemRequest,
  RequestUpdateAmazonItemsRequest,
  RequestUpdateAmazonItemsStatusRequest,
  ResponseBulkRegisterAmazonItemsResponse,
  ResponseGetAmazonItemsListResponse,
  ResponseGetReportItemsCsvListResponse,
  ResponseGetTaskProgressResponse,
  ResponseRegistAmazonItemsResponse,
} from '../models/index';
import {
    RequestBulkRegisterAmazonItemsRequestFromJSON,
    RequestBulkRegisterAmazonItemsRequestToJSON,
    RequestGetAmazonItemsListRequestFromJSON,
    RequestGetAmazonItemsListRequestToJSON,
    RequestGetReportItemsCsvListRequestFromJSON,
    RequestGetReportItemsCsvListRequestToJSON,
    RequestGetTaskProgressRequestFromJSON,
    RequestGetTaskProgressRequestToJSON,
    RequestRegistAmazonItemsRequestFromJSON,
    RequestRegistAmazonItemsRequestToJSON,
    RequestRestoreAmazonItemRequestFromJSON,
    RequestRestoreAmazonItemRequestToJSON,
    RequestUpdateAmazonItemsRequestFromJSON,
    RequestUpdateAmazonItemsRequestToJSON,
    RequestUpdateAmazonItemsStatusRequestFromJSON,
    RequestUpdateAmazonItemsStatusRequestToJSON,
    ResponseBulkRegisterAmazonItemsResponseFromJSON,
    ResponseBulkRegisterAmazonItemsResponseToJSON,
    ResponseGetAmazonItemsListResponseFromJSON,
    ResponseGetAmazonItemsListResponseToJSON,
    ResponseGetReportItemsCsvListResponseFromJSON,
    ResponseGetReportItemsCsvListResponseToJSON,
    ResponseGetTaskProgressResponseFromJSON,
    ResponseGetTaskProgressResponseToJSON,
    ResponseRegistAmazonItemsResponseFromJSON,
    ResponseRegistAmazonItemsResponseToJSON,
} from '../models/index';

export interface AmazonItemsGetAmazonItemsPostRequest {
    req: RequestGetAmazonItemsListRequest;
}

export interface AmazonItemsGetReportItemsCsvListPostRequest {
    req: RequestGetReportItemsCsvListRequest;
}

export interface AmazonItemsRegisterAmazonItemsPostRequest {
    req: RequestRegistAmazonItemsRequest;
}

export interface AmazonItemsRegisterBulkAmazonItemsPostRequest {
    req: RequestBulkRegisterAmazonItemsRequest;
}

export interface AmazonItemsRestoreAmazonItemPostRequest {
    req: RequestRestoreAmazonItemRequest;
}

export interface AmazonItemsStatusreceiptGetTaskProgressPostRequest {
    req: RequestGetTaskProgressRequest;
}

export interface AmazonItemsUpdateAmazonItemsPostRequest {
    req: RequestUpdateAmazonItemsRequest;
}

export interface AmazonItemsUpdateAmazonItemsStatusPostRequest {
    req: RequestUpdateAmazonItemsStatusRequest;
}

/**
 * 
 */
export class AmazonItemsApi extends runtime.BaseAPI {

    /**
     * AmazonItemsを取得
     * AmazonItems を取得
     */
    async amazonItemsGetAmazonItemsPostRaw(requestParameters: AmazonItemsGetAmazonItemsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseGetAmazonItemsListResponse>> {
        if (requestParameters['req'] == null) {
            throw new runtime.RequiredError(
                'req',
                'Required parameter "req" was null or undefined when calling amazonItemsGetAmazonItemsPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/amazonItems/GetAmazonItems`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RequestGetAmazonItemsListRequestToJSON(requestParameters['req']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseGetAmazonItemsListResponseFromJSON(jsonValue));
    }

    /**
     * AmazonItemsを取得
     * AmazonItems を取得
     */
    async amazonItemsGetAmazonItemsPost(requestParameters: AmazonItemsGetAmazonItemsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseGetAmazonItemsListResponse> {
        const response = await this.amazonItemsGetAmazonItemsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * アイテムCSVデータ取得
     * アイテムCSVデータ取得
     */
    async amazonItemsGetReportItemsCsvListPostRaw(requestParameters: AmazonItemsGetReportItemsCsvListPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseGetReportItemsCsvListResponse>> {
        if (requestParameters['req'] == null) {
            throw new runtime.RequiredError(
                'req',
                'Required parameter "req" was null or undefined when calling amazonItemsGetReportItemsCsvListPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/amazonItems/GetReportItemsCsvList`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RequestGetReportItemsCsvListRequestToJSON(requestParameters['req']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseGetReportItemsCsvListResponseFromJSON(jsonValue));
    }

    /**
     * アイテムCSVデータ取得
     * アイテムCSVデータ取得
     */
    async amazonItemsGetReportItemsCsvListPost(requestParameters: AmazonItemsGetReportItemsCsvListPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseGetReportItemsCsvListResponse> {
        const response = await this.amazonItemsGetReportItemsCsvListPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * AmazonItems、itemsを登録
     * AmazonItems、items を登録
     */
    async amazonItemsRegisterAmazonItemsPostRaw(requestParameters: AmazonItemsRegisterAmazonItemsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseRegistAmazonItemsResponse>> {
        if (requestParameters['req'] == null) {
            throw new runtime.RequiredError(
                'req',
                'Required parameter "req" was null or undefined when calling amazonItemsRegisterAmazonItemsPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/amazonItems/RegisterAmazonItems`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RequestRegistAmazonItemsRequestToJSON(requestParameters['req']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseRegistAmazonItemsResponseFromJSON(jsonValue));
    }

    /**
     * AmazonItems、itemsを登録
     * AmazonItems、items を登録
     */
    async amazonItemsRegisterAmazonItemsPost(requestParameters: AmazonItemsRegisterAmazonItemsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseRegistAmazonItemsResponse> {
        const response = await this.amazonItemsRegisterAmazonItemsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * CSVインポートによる複数データを登録
     * CSVインポートによる複数データを登録
     */
    async amazonItemsRegisterBulkAmazonItemsPostRaw(requestParameters: AmazonItemsRegisterBulkAmazonItemsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseBulkRegisterAmazonItemsResponse>> {
        if (requestParameters['req'] == null) {
            throw new runtime.RequiredError(
                'req',
                'Required parameter "req" was null or undefined when calling amazonItemsRegisterBulkAmazonItemsPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/amazonItems/RegisterBulkAmazonItems`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RequestBulkRegisterAmazonItemsRequestToJSON(requestParameters['req']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseBulkRegisterAmazonItemsResponseFromJSON(jsonValue));
    }

    /**
     * CSVインポートによる複数データを登録
     * CSVインポートによる複数データを登録
     */
    async amazonItemsRegisterBulkAmazonItemsPost(requestParameters: AmazonItemsRegisterBulkAmazonItemsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseBulkRegisterAmazonItemsResponse> {
        const response = await this.amazonItemsRegisterBulkAmazonItemsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 商品の復元
     * 商品の復元
     */
    async amazonItemsRestoreAmazonItemPostRaw(requestParameters: AmazonItemsRestoreAmazonItemPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<boolean>> {
        if (requestParameters['req'] == null) {
            throw new runtime.RequiredError(
                'req',
                'Required parameter "req" was null or undefined when calling amazonItemsRestoreAmazonItemPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/amazonItems/RestoreAmazonItem`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RequestRestoreAmazonItemRequestToJSON(requestParameters['req']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<boolean>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * 商品の復元
     * 商品の復元
     */
    async amazonItemsRestoreAmazonItemPost(requestParameters: AmazonItemsRestoreAmazonItemPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<boolean> {
        const response = await this.amazonItemsRestoreAmazonItemPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * TaskProgress
     * TaskProgress を取得
     */
    async amazonItemsStatusreceiptGetTaskProgressPostRaw(requestParameters: AmazonItemsStatusreceiptGetTaskProgressPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ResponseGetTaskProgressResponse>>> {
        if (requestParameters['req'] == null) {
            throw new runtime.RequiredError(
                'req',
                'Required parameter "req" was null or undefined when calling amazonItemsStatusreceiptGetTaskProgressPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/amazonItems/statusreceipt/GetTaskProgress`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RequestGetTaskProgressRequestToJSON(requestParameters['req']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ResponseGetTaskProgressResponseFromJSON));
    }

    /**
     * TaskProgress
     * TaskProgress を取得
     */
    async amazonItemsStatusreceiptGetTaskProgressPost(requestParameters: AmazonItemsStatusreceiptGetTaskProgressPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ResponseGetTaskProgressResponse>> {
        const response = await this.amazonItemsStatusreceiptGetTaskProgressPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * AmazonItems、itemsを更新
     * AmazonItems、items を更新
     */
    async amazonItemsUpdateAmazonItemsPostRaw(requestParameters: AmazonItemsUpdateAmazonItemsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseRegistAmazonItemsResponse>> {
        if (requestParameters['req'] == null) {
            throw new runtime.RequiredError(
                'req',
                'Required parameter "req" was null or undefined when calling amazonItemsUpdateAmazonItemsPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/amazonItems/UpdateAmazonItems`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RequestUpdateAmazonItemsRequestToJSON(requestParameters['req']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseRegistAmazonItemsResponseFromJSON(jsonValue));
    }

    /**
     * AmazonItems、itemsを更新
     * AmazonItems、items を更新
     */
    async amazonItemsUpdateAmazonItemsPost(requestParameters: AmazonItemsUpdateAmazonItemsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseRegistAmazonItemsResponse> {
        const response = await this.amazonItemsUpdateAmazonItemsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ステータスのみ更新
     * ステータスのみ更新
     */
    async amazonItemsUpdateAmazonItemsStatusPostRaw(requestParameters: AmazonItemsUpdateAmazonItemsStatusPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<boolean>> {
        if (requestParameters['req'] == null) {
            throw new runtime.RequiredError(
                'req',
                'Required parameter "req" was null or undefined when calling amazonItemsUpdateAmazonItemsStatusPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/amazonItems/UpdateAmazonItemsStatus`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RequestUpdateAmazonItemsStatusRequestToJSON(requestParameters['req']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<boolean>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * ステータスのみ更新
     * ステータスのみ更新
     */
    async amazonItemsUpdateAmazonItemsStatusPost(requestParameters: AmazonItemsUpdateAmazonItemsStatusPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<boolean> {
        const response = await this.amazonItemsUpdateAmazonItemsStatusPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
